<template>
  <!-- 用户注册页面 -->
  <div class="register cognition__content-main">
    <div class="register__sucker">
      已有账号？
      <router-link to="/login">立即登录</router-link>
    </div>
    <div class="register__title cognition__content-title">用户注册</div>
    <el-form :model="regiForm" :rules="rules" ref="regiForm">
      <el-form-item prop="mobile" label="手机号">
        <el-input v-model="regiForm.mobile" placeholder="请输入手机号" :maxlength="50" />
      </el-form-item>
      <el-form-item prop="code" label="验证码">
        <el-input v-model="regiForm.code" placeholder="请输入验证码" :maxlength="50">
          <el-button slot="append" @click="sendMobile" :disabled="!!countDown">{{codeTitle}}</el-button>
        </el-input>
      </el-form-item>
      <el-form-item prop="name" label="姓名">
        <el-input v-model="regiForm.name" placeholder="请输入姓名" :maxlength="50" />
      </el-form-item>
      <el-form-item prop="email" label="email">
        <el-input v-model="regiForm.email" placeholder="请输入邮箱" :maxlength="50" />
      </el-form-item>
      <el-form-item prop="password" label="密码">
        <el-input show-password v-model="regiForm.password" placeholder="请输入密码" :maxlength="50" />
      </el-form-item>
      <el-form-item prop="doublePwd" label="确认密码">
        <el-input show-password v-model="regiForm.doublePwd" placeholder="请再次输入密码" :maxlength="50" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onRegi">
          注册
        </el-button>
        <router-link to="/login">
          <el-button>返回登录</el-button>
        </router-link>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { encryptByDES } from "@/util";
import { validatorMobile } from '@/util/validate'
import { registerApi, registerSendCodeApi, isExistApi, getSecretKeyApi } from '@/util/api'

export default {
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.regiForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    const mobileIsExist = (() => {
      let mobile = '', errMsg = ''
      return (rule, value, callback) => {
        value = (value || '').trim()
        if(value && mobile !== value) {
          mobile = value
          isExistApi({
            mobile: value, 
            noToken: true
          }, false).then(res => {
            if (res.code === 0) {
              if(!res.data) {
                errMsg = ''
                callback()
              } else {
                errMsg = "该用户名已经存在！"
                callback(new Error(errMsg))
              }
            }
          });
        } else if (mobile === value) {
          errMsg ? callback(new Error(errMsg)) : callback()
        }
      }
    })()

    return {
      regiForm: {
        mobile: "",
        name: "",
        email: "",
        password: "",
        doublePwd: ""
      },
      countDown: 0,
      timer: null,
      rules: {
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: validatorMobile, trigger: "blur" },
          { validator: mobileIsExist, trigger: 'blur' }
        ],
        code: [
          { required: true, min: 6, max: 6, message: "请输入6位验证码", trigger: "blur" }
        ],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        email: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"]
          }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, message: "密码要大于 6 个字符", trigger: "blur" }
        ],
        doublePwd: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    codeTitle() {
      return this.countDown ? `${this.countDown}秒后重新获取` : '发送验证码'
    }
  },
  methods: {
    // 发送验证码
    sendMobile() {
      this.$refs['regiForm'].validateField('mobile', err => {
        if(!err) {
          registerSendCodeApi({ mobile: this.regiForm.mobile.trim() }).then(res => {
            if(res.code === 0) {
              this.$message({ type: 'success', message: `验证码已发送` })
              clearInterval(this.timer)
              this.countDown = 60
              this.timer = setInterval(() => {
                this.countDown--
                if(!this.countDown) clearInterval(this.timer)
              }, 1000)
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    onRegi() {
      // 先加密 密码
      this.$refs["regiForm"].validate(valid => {
        if (valid) {
          getSecretKeyApi(this.regiForm.mobile)
          .then(res => {
            if (res.code === 0) {
              // 秘钥
              const privateKey = res.data;
              const password = encryptByDES(
                this.regiForm.password,
                privateKey
              );

              this.register(password);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 注册
    register(password) {
      const params = { ...this.regiForm, noToken: true, password };
      delete params.doublePwd;

      registerApi(params).then(res => {
        if (res.code === 0) {
          const h = this.$createElement;
          this.$msgbox({
            title: "通知",
            message: h("div", null, [
              h("p", null, `${this.regiForm.name}，您的申请已成功提交！`),
              h("p", null, "请耐心等待管理员审核。"),
              h("p", null, "审核结果将由邮件告知，请注意查收")
            ]),
            center: true,
            confirmButtonText: "我知道了",
            callback: () => {
              this.$router.push("/login").catch(data => console.log(data));
            }
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    login() {
      this.$router.push({ path: "/login" }).catch(data => console.log(data));
    }
  }
};
</script>

<style scoped lang="less">
.register {
  .register__sucker {
    position: absolute;
    top: 16px;
    right: 160px;
    font-size: 14px;
    line-height: 20px;
    color: @label-color;
  }
  .register__required {
    position: relative;
    &::after {
      content: "*";
      color: #dd413d;
      position: absolute;
      top: 0;
      left: -15px;
      width: 15px;
      height: 38px;
      line-height: 38px;
    }
  }
}
</style>
